import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { I18n } from "utils/i18n-shim"
import { saveAuthCookie } from "utils/api"
import { useQueryParams } from "shared/hooks"
import * as WS from "shared/lib/web-sockets"
import { setRollbarUser } from "shared/lib/rollbar"

import useNotifications from "hooks/useNotifications"
import useHandleServerErrors from "hooks/useHandleServerErrors"
import { loginSuccess } from "store/modules/common/auth"
import { useLogin } from "../api"
import { twoFactorAuthSetupParams } from "../lib"

export const useHandleLogin = ({ setIsTwoFactor } = {}) => {
  const login = useLogin()
  const handleServerErrors = useHandleServerErrors()
  const query = useQueryParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const { showInfo } = useNotifications()

  return useCallback(
    ({ email, password, otp_attempt, otp_by_email }, formik) => {
      return login.mutate(
        { email, password, otp_attempt, otp_by_email },
        {
          onSuccess: (response) => {
            if (response.data.account_require_2fa) {
              history.push(
                twoFactorAuthSetupParams({ email, password }, response.data)
              )

              return
            }

            if (response.data.two_factor) {
              setIsTwoFactor(true)

              if (response.data.disable_otp_by_email) {
                showInfo(I18n.t("login.code-send-disabled"))

                return
              }

              if (response.data.otp_by_email) {
                showInfo(I18n.t("login.code-sent"))
              }

              return
            }
            const user = response.data.user
            saveAuthCookie(null, response.data.auth_token)
            dispatch(loginSuccess(response.data))

            if (user?.id) WS.setup(user)
            setRollbarUser(user?.id)

            const location = query.get("location")
            if (location) {
              window.location.href = location
            } else {
              history.push("/react")
            }
          },
          onError: (error) => {
            handleServerErrors(error, formik)
            // To highlight the fields
            formik.setErrors({ email: " ", password: " " })
          },
          onSettled: () => {
            formik.setSubmitting(false)
          }
        }
      )
    },
    [
      handleServerErrors,
      login,
      query,
      history,
      dispatch,
      setIsTwoFactor,
      showInfo
    ]
  )
}
